export default "__VITE_ASSET__CmKeJ6UP__"